import {asyncRouteMap, constantRouterMap,routes} from '@/router/index.js'
import store from "@/store"

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param routes asyncRouterMap
 * @param roles
 */
// function filterAsyncRouter (routes, role) {
//   console.log(routes,'storeforeach')
//   const res = []
//   routes.forEach(route => {
//     const tmp = {...route}
//     if (tmp.children) {
//       tmp.children = filterAsyncRouter(tmp.children, role)
//     }
//     res.push(tmp)
//   })
//
//   return res
// }

/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
/*function addDynamicMenuRoutes1 (menuList = [], routes = []) {
  var temp = []
  for (var i = 0; i < menuList.length; i++) {
    if (menuList[i].children && menuList[i].children.length >= 1) {
      temp = temp.concat(menuList[i].children)
    } else if (menuList[i].url && /\S/.test(menuList[i].url)) {
      menuList[i].url = menuList[i].url.replace(/^\//, '')
      // 创建路由配置
      var route = {
        path: menuList[i].url,
        component: null,
        name: menuList[i].name,
        meta: {
          menuId: menuList[i].menuId,
          title: menuList[i].name,
          isDynamic: true,
          isTab: true,
          iframeUrl: ''
        }
      }
      // url以http[s]://开头, 通过iframe展示
      if (isURL(menuList[i].url)) {
        route['path'] = menuList[i].url
        route['name'] = menuList[i].name
        route['meta']['iframeUrl'] = menuList[i].url
      } else {
        try {
          // 根据菜单URL动态加载vue组件，这里要求vue组件须按照url路径存储
          // 如url="sys/user"，则组件路径应是"@/views/sys/user.vue",否则组件加载不到
          let array = menuList[i].url.split('/')
          let url = array[0].substring(0,1).toUpperCase()+array[0].substring(1) + '/' + array[1].substring(0,1).toUpperCase()+array[1]  .substring(1)
          route['component'] = resolve => require([`@/views/${url}`], resolve)
        } catch (e) {}
      }
      routes.push(route)
    }
  }
  if (temp.length >= 1) {
    this.addDynamicMenuRoutes(temp, routes)
  } else {
    console.log(routes)
  }
  return routes
}*/

 function button ( buttonList,list ) {
  buttonList.forEach(item=>{
    list.push(item.code)
  })
   return true
}

function addDynamicMenuRoutes (menuList = [], routes = []){

  menuList.forEach((item,index,arr) =>　{
    if( item.type == 'menu' ){

    var route = {
      path: '',
      component: {},
      name: '',
      meta: {
        title: '',
        icon: ''
      }
    }

      var path = item.urlPath
      route['path'] = path
      route['name'] = item.name
      route['component'] = resolve => require([`@/views/${item.url}`], resolve)
      route['meta']['title'] = item.name
      route['meta']['icon'] = item.icon
      routes.push(route)


    if(item.children && item.children[0].type == 'acl'){
           button(item.children,store.state.permission.buttonPermission)
          item.children=null
    }else if(item.children){
      addDynamicMenuRoutes(item.children,routes)
    }
    }else if (item.type == 'acl'){

      //console.log(item)
    }
  })
}


const permission = {
  state: {
    routers: routes,
    addRouters: [],
    buttonPermission:[]

  },
  mutations: {
    SET_ROUTERS: (state, routers) => {

      state.addRouters = routers
      state.routers = routes.concat(routers)
      //console.log(state)
    }
  },
  actions: {
    GenerateRoutes ({commit}, role) {
      return new Promise(resolve => {
        /*let accessedRouters
        if (role === 'admin') {
          accessedRouters = asyncRouterMap
        } else {
          accessedRouters = filterAsyncRouter(asyncRouterMap, role)
        }*/
        //console.log('addDynamicMenuRoutes值行开始')
        //console.log(store.state.permission.buttonPermission)
        addDynamicMenuRoutes(role,routes[0].children,store.state.permission.buttonPermission)
        //console.log('addDynamicMenuRoutes值行结束')
       // console.log(routes,'值行结束得到的值' )
        //console.log(routes[0].children,'值行结束得到的值'  )
        //{ path: '/Login', component:  () => import('@/views/login.vue/index') }
        // asyncRouterMap.forEach((item)=>{
        //   console.log(item)
        // })
        commit('SET_ROUTERS', routes)
        resolve()
      })
    }
  }
}

export default permission



// WEBPACK FOOTER //
// ./src/store/permission.js